var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":19}},[_c('div',{staticClass:"chart",staticStyle:{"height":"350px","padding":"20px","padding-left":"80px"},attrs:{"id":"D2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }